import { get, set, del } from "idb-keyval";
import { optimizeImage } from "./comprimir-image";


export async function saveImageBlob(key: string, fileBlob: Blob) {
  try {
    // Optimizar la imagen antes de guardarla
    const optimizedBlob = await optimizeImage(fileBlob);
    
    // Guardar la imagen optimizada en IndexedDB
    await set(key, optimizedBlob);
    
  } catch (error) {
    // En caso de error en la optimización, guardar la imagen original
    await set(key, fileBlob);
  }
}

/**
 * Obtiene el Blob correspondiente a una key.
 */
export async function getImageBlob(key: string): Promise<Blob | undefined> {
  const blob = await get(key);
  return blob || undefined;
}

/**
 * Elimina una key de IndexedDB.
 */
export async function removeImageBlob(key: string): Promise<void> {
  await del(key);
}

